import { del } from 'utils/http/del';

export function userDashboardApiDeleteSavedSearch(searchId: string) {
  return del(`/data/saved-searches/${searchId}`);
}
